import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  lenis = new Lenis({ duration: 1.15, smoothWheel: true });
  let running = true;
  const raf = (time) => {
    if (!running) return;
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
  return () => {
    running = false;
    lenis.destroy();
    lenis = null;
  };
}

export const getLenis = () => lenis;
